(function () {
  var content = document.querySelector('[data-bd-pol-content]');
  var toc = document.querySelector('[data-bd-pol-toc]');
  var sidebar = document.querySelector('[data-bd-pol-sidebar]');
  var layout = document.querySelector('.bd-pol__layout');

  if (!content || !toc) return;

  var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));

  if (headings.length < 2) {
    if (sidebar) sidebar.style.display = 'none';
    if (layout) layout.style.gridTemplateColumns = '1fr';
    return;
  }

  var usedIds = {};
  var links = [];

  headings.forEach(function (h) {
    if (!h.id) {
      var slug = h.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
      if (!slug) slug = 'section';
      if (usedIds[slug]) {
        usedIds[slug]++;
        slug = slug + '-' + usedIds[slug];
      } else {
        usedIds[slug] = 1;
      }
      h.id = 'bd-pol-h-' + slug;
    }

    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    if (h.tagName === 'H3') a.className = 'bd-pol__toc-sub';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', '#' + h.id);
    });
    toc.appendChild(a);
    links.push({ heading: h, link: a });
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var match = links.filter(function (l) {
            return l.heading === entry.target;
          })[0];
          if (!match) return;
          if (entry.isIntersecting) {
            links.forEach(function (l) {
              l.link.classList.remove('is-active');
            });
            match.link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-100px 0px -70% 0px' }
    );
    headings.forEach(function (h) {
      observer.observe(h);
    });
  }
})();